import { useSearchParams } from "react-router-dom";
import PdfViewer from "./organisms/PdfViewer";

const FileViewer = () => {
  const [searchParams] = useSearchParams();

  //  First, try to get from URL, else from sessionStorage
  let fileUrl = searchParams.get("url");

  // JIRA: [EVES-4006] - Transaction receipt view
  // Author: Abhishek Bharti
  // Date: 14/11/2025
  if (!fileUrl) {
    const base64Data = sessionStorage.getItem("pdfBase64");
    if (base64Data && base64Data.trim() !== "") {
      try {
        // Validate base64 data format (should contain comma for data:application/pdf;base64,)
        const base64Parts = base64Data.split(",");
        if (base64Parts.length < 2 || !base64Parts[1]) {
          console.error(
            "Invalid base64 data format: missing comma or data portion"
          );
          sessionStorage.removeItem("pdfBase64");
        } else {
          const base64String = base64Parts[1].trim();
          if (base64String.length === 0) {
            console.error("Invalid base64 data: empty data portion");
            sessionStorage.removeItem("pdfBase64");
          } else {
            // Decode base64 string
            const byteCharacters = atob(base64String);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);

            // Validate byteArray is not empty before creating blob
            if (byteArray.length > 0) {
              const blob = new Blob([byteArray], { type: "application/pdf" });
              fileUrl = URL.createObjectURL(blob);
            } else {
              console.error("Invalid base64 data: decoded data is empty");
              sessionStorage.removeItem("pdfBase64");
            }
          }
        }
      } catch (error) {
        console.error("Error processing base64 data:", error);
        sessionStorage.removeItem("pdfBase64");
      }
    }
  }

  const paymentID = searchParams.get("paymentID");
  const invoiceID = searchParams.get("invoiceID");
  const receiptID = searchParams.get("receiptID");

  //  If neither URL nor sessionStorage has it, show error
  if (!fileUrl) return <div>Invalid or missing receipt URL.</div>;

  // Only decode if it's *not* a blob URL
  const decodedUrl = fileUrl.startsWith("blob:")
    ? fileUrl
    : decodeURIComponent(fileUrl);

  const filename = receiptID
    ? `${receiptID}.pdf`
    : invoiceID
    ? `${invoiceID}.pdf`
    : paymentID
    ? `${paymentID}.pdf`
    : "receipt.pdf";

  return <PdfViewer fileUrl={decodedUrl} customFilename={filename} />;
};

export default FileViewer;
